/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
// import CustomCursor from './site/CustomCursor';
import ProductGallery from './site/productGallery';
import ProductAddToCart from './site/productAddToCart';
import Tabs from './site/tabs';
import Product from './site/product';
import TruncateTestimonials from './site/productTestimonialPopup';
import Header from './site/header';
import EqualHeights from './site/equalHeights';
import InquiryFormProducts from './site/inquiryFormProducts';
import InquiryFormSubmission from './site/inquiryFormSubmission';
import SearchRepLocations from './site/searchRepLocations';
import TabsAccordion from './site/accordion';
import HistoryTimeline from './site/historyTimeline';
import Search from './site/search';
import Counter from './site/counter';
import DetectBrowser from './site/detectBrowser';
import LoadMoreSpecialProducts from './site/loadMoreSpecialProducts';
import LoadMoreProductsList from './site/loadMoreProductsList';
import VideoSection from './site/videoSection';
import LoadMoreTabs from './site/loadMoreTabs';
import VariantInfo from './site/variantInfo';
import LoginForm from './site/SalesLogin';
import TabsSwitcher from './site/tabsSwitcher';
import LoadPosts from './site/posts/loadPosts';
import BlogSearch from './site/posts/blogSearch';
// import SinglePost from './site/posts/singlePost';
import ProductPGallery from './site/posts/productGallery';
import HeroKibarro from './site/heroKibarro';
import StoryBlock from './site/storyBlock';
import FloatingSection from './site/floatingSection';
import ScrollingText from './site/scrollingText';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	DetectBrowser.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	// CustomCursor.init();
	ProductGallery.init();
	ProductAddToCart.init();
	Tabs.init();
	Product.init();
	TruncateTestimonials.init();
	Header.init();
	EqualHeights.init();
	InquiryFormProducts.init();
	InquiryFormSubmission.init();
	SearchRepLocations.init();
	TabsAccordion.init();
	HistoryTimeline.init();
	Search.init();
	Counter.init();
	LoadMoreSpecialProducts.init();
	LoadMoreProductsList.init();
	LoadMoreTabs.init();
	VariantInfo.init();
	LoginForm.init();
	TabsSwitcher.init();
	LoadPosts.init();
	BlogSearch.init();
	// SinglePost.init();
	ProductPGallery.init();
	HeroKibarro.init();
	StoryBlock.init();
	FloatingSection.init();
	ScrollingText.init();
	VideoSection.init();
});
